import { Routes, Route, Navigate } from 'react-router-dom'
import LoginPage from './pages/LoginPage'
import SetupIdPPage from './pages/SetupIdPPage'
import CatalogPage from './pages/CatalogPage'
import SSHTerminal from './pages/SSHTerminal'
import VNCViewer from './pages/VNCViewer'
import RDPViewer from './pages/RDPViewer'
import AuditLog from './pages/AuditLog'
import NativeAccessSetupPage from './pages/NativeAccessSetupPage'
import AppShell from './components/layout/AppShell'
import SessionChrome from './components/layout/SessionChrome'
import AdminGuard from './components/AdminGuard'
import AdminDashboardPage from './pages/AdminDashboardPage'
import AdminPoolsPage from './pages/AdminPoolsPage'
import AdminConnectorsPage from './pages/AdminConnectorsPage'
import AdminResourcesPage from './pages/AdminResourcesPage'
import AdminTagsPage from './pages/AdminTagsPage'
import AdminTagGroupsPage from './pages/AdminTagGroupsPage'
import AdminIdentityProviderPage from './pages/AdminIdentityProviderPage'
import AdminDirectoryPage from './pages/AdminDirectoryPage'
import AdminPoliciesPage from './pages/AdminPoliciesPage'
import AdminCliSettingsPage from './pages/AdminCliSettingsPage'
import AdminSSHNetworksPage from './pages/AdminSSHNetworksPage'
import DesignSystemPage from './pages/DesignSystemPage'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Tenant IdP setup wizard — unauthenticated by session, gated by a
          setup token instead (ADR-010 §5/§10). Deliberately outside
          AppShell/AdminGuard: this must work before any Idefy session exists. */}
      <Route path="/setup/idp" element={<SetupIdPPage />} />

      {import.meta.env.DEV && (
        <Route path="/design-system" element={<DesignSystemPage />} />
      )}

      {/* Session viewers — compact chrome, no sidebar */}
      <Route element={<SessionChrome />}>
        <Route path="/session/ssh/:resourceId" element={<SSHTerminal />} />
        <Route path="/session/vnc/:resourceId" element={<VNCViewer />} />
        <Route path="/session/rdp/:resourceId" element={<RDPViewer />} />
      </Route>

      {/* User portal */}
      <Route element={<AppShell mode="user" />}>
        <Route index element={<Navigate to="/catalog" replace />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/native-access-setup" element={<NativeAccessSetupPage />} />
      </Route>

      {/* Audit Log moved under /admin (admin-only — see G25). Redirect the
          old URL so bookmarks/links don't 404; AdminGuard still applies at
          the destination for non-admin users. */}
      <Route path="/audit" element={<Navigate to="/admin/audit" replace />} />

      {/* Admin portal */}
      <Route
        path="/admin"
        element={
          <AdminGuard>
            <AppShell mode="admin" />
          </AdminGuard>
        }
      >
        <Route index element={<AdminDashboardPage />} />
        <Route path="pools" element={<AdminPoolsPage />} />
        <Route path="connectors" element={<AdminConnectorsPage />} />
        <Route path="resources" element={<AdminResourcesPage />} />
        <Route path="tags" element={<AdminTagsPage />} />
        <Route path="resource-groups" element={<AdminTagGroupsPage />} />
        <Route path="identity-provider" element={<AdminIdentityProviderPage />} />
        <Route path="directory" element={<AdminDirectoryPage />} />
        <Route path="policies" element={<AdminPoliciesPage />} />
        <Route path="cli-settings" element={<AdminCliSettingsPage />} />
        <Route path="ssh-networks" element={<AdminSSHNetworksPage />} />
        <Route path="audit" element={<AuditLog />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
